import { createRequest, HttpMethod } from 'ehs-react';
import type { icModel } from 'generated-ts-common';
import type { at } from '../generated/Beans';

type LoginResponse = at.sense.hooks.login.LoginResponse;
type LoginErrorDetails = at.sense.hooks.login.LoginErrorDetails;

type MenuUser = icModel.saf.infrastructure.model.menu.MenuUser;

/**
 * An AJAX request to request the menu users.
 */
export const requestMenuUsers = createRequest<void, MenuUser[]>({
  operation: 'retrieveMenuUsers',
  method: HttpMethod.GET,
  returnsArray: true
});

interface SelectUserRequest {
  /** The selected menu user. */
  selectedMenuUser: MenuUser;
}
/**
 * An AJAX request to select a menu user.
 */
export const selectUser = createRequest<SelectUserRequest, string>({
  operation: 'handleMenuClick',
  method: HttpMethod.POST,
  returnsArray: false
});

interface CheckDocumentRequest {
  /** The portal name. */
  portalName: string | null;
}

/**
 * An AJAX call to determine if the help document exists.
 */
export const checkIfHelpDocumentExists = createRequest<
  CheckDocumentRequest,
  boolean
>({
  operation: 'checkIfHelpDocumentExists',
  method: HttpMethod.GET,
  returnsArray: false
});

export const doAssertionRefresh = createRequest<void, string>({
  operation: 'doAssertionRefresh',
  method: HttpMethod.GET,
  returnsArray: false
});

export interface LoginRequest {
  user: string;
  password: string;
  fingerprint?: string;
}

export const doAuthenticateUserCall = createRequest<
  LoginRequest,
  LoginResponse
>({
  operation: 'authenticateUser',
  method: HttpMethod.POST,
  returnsArray: false
});

export interface SendTwoFactorPasswordRequest {
  user: string;
  password: string;
  assertionId?: string;
  twofa?: string;
}

/**
 * An AJAX request to send an OTP to the user context.
 * @return details about the sent OTP
 */
export const sendTwoFactorPassword = createRequest<
  SendTwoFactorPasswordRequest,
  LoginResponse
>({
  operation: 'sendTwoFactorPassword',
  method: HttpMethod.POST
});

export interface VerifyTwoFactorPasswordRequest {
  user: string;
  password: string;
  fingerprint?: string;
  assertionId?: string;
  otp: string;
}

/**
 * An AJAX request to send an OTP to the user context.
 * @return details about the sent OTP
 */
export const verifyTwoFactorPassword = createRequest<
  VerifyTwoFactorPasswordRequest,
  LoginErrorDetails
>({
  operation: 'verifyTwoFactorPassword',
  method: HttpMethod.POST
});
